<ng-container *ngIf="state === 'booking_calendar'">
  <div class="single-row-container">
    <app-listing-item [listItem]="trainerItem" [activeItemCounter]="0" [singleRow]="true"></app-listing-item>
  </div>
  <app-calendar-container [profile]="profile"
                          [load_playhour_data]="true" [allow_events_edit]="true" [admin_view]="true">
  </app-calendar-container>
</ng-container>
<div *ngIf="state === 'loading'" class="internal-spinner">
  <svg class="spinner" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
  </svg>
</div>
